import React from "react";
//#region types
import { WintSuperkollAPIModelFinancialReport } from "wint-api-client/dist/types";
import { AccountingFormTypes } from "models/formTypes";
//#endregion
//#region components
import { useFilterContext } from "components/common";
import useMonthlyReportDefaults from "./useMonthlyReportDefaults";
//#endregion
import { DateHelper } from "utils/helpers";

function useMonthlyReportHelpers(
  getReport: (
    filter: WintSuperkollAPIModelFinancialReport.FinancialReportMonthlyFilter
  ) => Promise<WintSuperkollAPIModelFinancialReport.FinancialReport>
) {
  const [loading, setLoading] = React.useState<boolean>(false);
  const [result, setResult] = React.useState<WintSuperkollAPIModelFinancialReport.FinancialReportRow[]>([]);
  const [filter, setFilter] = React.useState<WintSuperkollAPIModelFinancialReport.FinancialReportMonthlyFilter>();
  const { filter: pageFilter, setFilter: setPageFilter } =
    useFilterContext<AccountingFormTypes.FinancialReportFilter>();

  const { getDefaultMonthRange } = useMonthlyReportDefaults();

  React.useEffect(() => {
    const defaultMonthRange = getDefaultMonthRange();
    setPageFilter({ monthRange: defaultMonthRange.monthRange }, true);
  }, []);

  React.useEffect(() => {
    const updateFilter = {
      ...(filter ?? ({} as WintSuperkollAPIModelFinancialReport.FinancialReportMonthlyFilter)),
      dimensions: pageFilter?.dimensions,
    };
    if (pageFilter?.monthRange?.start && pageFilter?.monthRange?.end) {
      updateFilter.startMonth = DateHelper.getYearMonthByDate(pageFilter.monthRange.start);
      updateFilter.endMonth = DateHelper.getYearMonthByDate(pageFilter.monthRange.end);
    } else {
      const defaultMonthRange = getDefaultMonthRange().yearMonthRange;
      updateFilter.startMonth = defaultMonthRange.startMonth;
      updateFilter.endMonth = defaultMonthRange.endMonth;
    }
    if (JSON.stringify(filter) !== JSON.stringify(updateFilter)) setFilter(updateFilter);
  }, [pageFilter]);

  React.useEffect(() => {
    if (filter) {
      setLoading(true);
      getReport(filter)
        .then((res) => setResult(res.rows ?? []))
        .finally(() => setLoading(false));
    }
  }, [filter]);
  return { result, filter, loading, pageFilter };
}

export default useMonthlyReportHelpers;
